// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CompleteOrder_pageWrap__U9HRP {
  padding: 4px 4px 32px;
}

.CompleteOrder_desktopTable__H2vtq {
  display: block;
}

.CompleteOrder_mobileList__BxCqH {
  display: none;
}

@media (max-width: 767px) {
  .CompleteOrder_desktopTable__H2vtq {
    display: none;
  }
  .CompleteOrder_mobileList__BxCqH {
    display: block;
  }
}

/* =========================================================
   Toolbar
   ========================================================= */
.CompleteOrder_toolbarRow__sigAR {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  border-bottom: 1px solid #EEF0F6;
}

.CompleteOrder_searchInput__IrTvP {
  padding: 9px 14px;
  border-radius: 10px;
  border: 1px solid #E5E7EB;
  font-size: 13.5px;
  background: #ffffff;
  min-width: 260px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.CompleteOrder_searchInput__IrTvP:focus {
  outline: none;
  border-color: #4c2fb3;
  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);
}

.CompleteOrder_spacer__IidHT {
  flex: 1 1;
}

/* =========================================================
   Status pills
   ========================================================= */
.CompleteOrder_pillBase__spIUm {
  display: inline-flex;
  align-items: center;
  padding: 3px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}
.CompleteOrder_pillGreen__VUJtw { background: #E9F9EF; color: #16A34A; }
.CompleteOrder_pillRed__jdTFK { background: #FDEDED; color: #DC2626; }
.CompleteOrder_pillAmber__g\\+5LD { background: #FFF7E6; color: #B45309; }
.CompleteOrder_pillBlue__2w\\+\\+W { background: #EAF1FF; color: #2563EB; }
.CompleteOrder_pillGrey__tmzBa { background: #F1F2F6; color: #6B7280; }

.CompleteOrder_emptyState__ko4ze {
  text-align: center;
  color: #9CA3AF;
  font-size: 13.5px;
  padding: 40px 0;
}

/* =========================================================
   Mobile card list
   ========================================================= */
.CompleteOrder_mobileCard__bbTwn {
  border: 1px solid #EEF0F6;
  border-radius: 14px;
  background: #ffffff;
  padding: 16px;
  margin-bottom: 12px;
}

.CompleteOrder_mobileRow__Q66Wz {
  display: flex;
  gap: 12px;
  padding: 4px 0;
  font-size: 13px;
}

.CompleteOrder_mobileLabel__O48zH {
  min-width: 120px;
  flex-shrink: 0;
  color: #6B7280;
  font-weight: 600;
}

.CompleteOrder_mobileValue__LaGMA {
  color: #1F2430;
  word-break: break-word;
}

.CompleteOrder_mobileActionRow__crRuB {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/order/CompleteOrder.module.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;AACF;;AAEA;;8DAE8D;AAC9D;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0DAA0D;AAC5D;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,SAAO;AACT;;AAEA;;8DAE8D;AAC9D;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA,kCAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,gCAAW,mBAAmB,EAAE,cAAc,EAAE;AAChD,mCAAa,mBAAmB,EAAE,cAAc,EAAE;AAClD,mCAAY,mBAAmB,EAAE,cAAc,EAAE;AACjD,iCAAY,mBAAmB,EAAE,cAAc,EAAE;;AAEjD;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;8DAE8D;AAC9D;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB","sourcesContent":[".pageWrap {\n  padding: 4px 4px 32px;\n}\n\n.desktopTable {\n  display: block;\n}\n\n.mobileList {\n  display: none;\n}\n\n@media (max-width: 767px) {\n  .desktopTable {\n    display: none;\n  }\n  .mobileList {\n    display: block;\n  }\n}\n\n/* =========================================================\n   Toolbar\n   ========================================================= */\n.toolbarRow {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 24px;\n  border-bottom: 1px solid #EEF0F6;\n}\n\n.searchInput {\n  padding: 9px 14px;\n  border-radius: 10px;\n  border: 1px solid #E5E7EB;\n  font-size: 13.5px;\n  background: #ffffff;\n  min-width: 260px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.searchInput:focus {\n  outline: none;\n  border-color: #4c2fb3;\n  box-shadow: 0 0 0 3px rgba(124, 92, 252, 0.15);\n}\n\n.spacer {\n  flex: 1;\n}\n\n/* =========================================================\n   Status pills\n   ========================================================= */\n.pillBase {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.pillGreen { background: #E9F9EF; color: #16A34A; }\n.pillRed { background: #FDEDED; color: #DC2626; }\n.pillAmber { background: #FFF7E6; color: #B45309; }\n.pillBlue { background: #EAF1FF; color: #2563EB; }\n.pillGrey { background: #F1F2F6; color: #6B7280; }\n\n.emptyState {\n  text-align: center;\n  color: #9CA3AF;\n  font-size: 13.5px;\n  padding: 40px 0;\n}\n\n/* =========================================================\n   Mobile card list\n   ========================================================= */\n.mobileCard {\n  border: 1px solid #EEF0F6;\n  border-radius: 14px;\n  background: #ffffff;\n  padding: 16px;\n  margin-bottom: 12px;\n}\n\n.mobileRow {\n  display: flex;\n  gap: 12px;\n  padding: 4px 0;\n  font-size: 13px;\n}\n\n.mobileLabel {\n  min-width: 120px;\n  flex-shrink: 0;\n  color: #6B7280;\n  font-weight: 600;\n}\n\n.mobileValue {\n  color: #1F2430;\n  word-break: break-word;\n}\n\n.mobileActionRow {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageWrap": `CompleteOrder_pageWrap__U9HRP`,
	"desktopTable": `CompleteOrder_desktopTable__H2vtq`,
	"mobileList": `CompleteOrder_mobileList__BxCqH`,
	"toolbarRow": `CompleteOrder_toolbarRow__sigAR`,
	"searchInput": `CompleteOrder_searchInput__IrTvP`,
	"spacer": `CompleteOrder_spacer__IidHT`,
	"pillBase": `CompleteOrder_pillBase__spIUm`,
	"pillGreen": `CompleteOrder_pillGreen__VUJtw`,
	"pillRed": `CompleteOrder_pillRed__jdTFK`,
	"pillAmber": `CompleteOrder_pillAmber__g+5LD`,
	"pillBlue": `CompleteOrder_pillBlue__2w++W`,
	"pillGrey": `CompleteOrder_pillGrey__tmzBa`,
	"emptyState": `CompleteOrder_emptyState__ko4ze`,
	"mobileCard": `CompleteOrder_mobileCard__bbTwn`,
	"mobileRow": `CompleteOrder_mobileRow__Q66Wz`,
	"mobileLabel": `CompleteOrder_mobileLabel__O48zH`,
	"mobileValue": `CompleteOrder_mobileValue__LaGMA`,
	"mobileActionRow": `CompleteOrder_mobileActionRow__crRuB`
};
export default ___CSS_LOADER_EXPORT___;
